import { http } from '@/api/httpAxios'
import { AxiosPromise } from 'axios'

export default class DictsAPI {
  public static getAuthorDegree(): AxiosPromise {
    return http.get('/dicts/author-degree?sort=["full", "ASC"]')
  }
  public static getAuthorPosition(): AxiosPromise {
    return http.get('/dicts/author-position?sort=["full", "ASC"]')
  }
  public static getPublicationQuartile(): AxiosPromise {
    return http.get('/dicts/publ-quartile?sort=["full", "ASC"]')
  }
  public static getConferenceType(): AxiosPromise {
    return http.get('/dicts/conf-type?sort=["full", "ASC"]')
  }
  public static getConferenceForm(): AxiosPromise {
    return http.get('/dicts/conf-form?sort=["full", "ASC"]')
  }
  public static getPublicationType(): AxiosPromise {
    return http.get('/dicts/publication-type?sort=["full", "ASC"]')
  }
  public static getClassifiersVac(): AxiosPromise {
    return http.get('/dicts/classifiers-vac?sort=["full", "ASC"]')
  }
  public static getClassifiersMon(): AxiosPromise {
    return http.get('/dicts/classifiers-mon?sort=["full", "ASC"]')
  }
  public static getLabourRel(): AxiosPromise {
    return http.get('/dicts/labour-rel?sort=["full", "ASC"]')
  }
  public static getWorkPositions(): AxiosPromise {
    return http.get('/dicts/work-positions?sort=["title", "ASC"]')
  }
  public static getAcademicDegree(): AxiosPromise {
    return http.get('/dicts/academic-degrees?sort=["title", "ASC"]')
  }
  public static getWorkDepartments(): AxiosPromise {
    return http.get('/dicts/work-departments?sort=["shortTitle", "ASC"]')
  }
  public static getWorkFunctions(): AxiosPromise {
    return http.get('/dicts/work-functions?sort=["title", "ASC"]')
  }
  public static getAcademicTitles(): AxiosPromise {
    return http.get('/dicts/academic-titles?sort=["title", "ASC"]')
  }
  public static getStudentGroups(): AxiosPromise {
    return http.get('/dicts/edugroups?limit=no&offset=no?sort=["group", "ASC"]')
  }
  public static getAlmostAllDict(): AxiosPromise {
    return http.get('/dicts/almost-all')
  }
}
